import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { SearchWidgetComponent } from 'components/accordion/search-widget/search-widget.component';
import { SearchBoxModule } from 'components/accordion/search-widget/search-box/search-box.module';
import { SearchResultsPanelModule } from 'components/accordion/search-widget/search-results-panel/search-results-panel.module';
import { LoadingModule } from 'shared/components/loading/loading.module';
import { InfoLabelModule } from 'shared/components/info-label/info-label.module';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forChild(),
    SearchBoxModule,
    SearchResultsPanelModule,
    LoadingModule,
    InfoLabelModule
  ],
  declarations: [
    SearchWidgetComponent
  ],
  exports: [
    SearchWidgetComponent
  ]
})
export class SearchWidgetModule {}
